import { EmptyState } from 'ui/emptyState';
import { ListEmptyTableState } from 'ui/illustrations';
import { EmptyStateWrapper } from '../../AudienceSelection.styled';
import { NoListEmptyStateSubtitle } from './NoListsEmptyStateSubtitle';

export const NO_LIST_TYPE_MATCHES_TITLE = 'No lists yet';

export const ListTypeEmptyState = () => (
  <EmptyStateWrapper data-test="campaign-editor-no-list-type-empty-state">
    <EmptyState
      Illustration={ListEmptyTableState}
      title={NO_LIST_TYPE_MATCHES_TITLE}
      subtitle={<NoListEmptyStateSubtitle />}
    />
  </EmptyStateWrapper>
);
